// extracted by mini-css-extract-plugin
module.exports = {"infoTable":"app-info-table_infoTable_o0Gl5","infoTableHeader":"app-info-table_infoTableHeader_3RG5C","infoTableBody":"app-info-table_infoTableBody_2PMqI"};